<template>
<!-- 客源变现 -->
<section class="viewContainer">
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="全部客户" name="first"/>
    <el-tab-pane label="销售记录" name="second"/>
  </el-tabs>

  <!-- 全部客户 -->
  <div v-show="activeName=='first'">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="小区名称：" style="display:flex;width:30%">
            <el-input  v-model="xiaoquName" placeholder="请输入小区名称" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="员工电话：" style="display:flex;width:30%">
            <el-input  v-model="orderNumber" placeholder="请输入员工手机号码" maxlength="11" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="客户手机号码：" label-width="50px" style="display:flex;width:30%">
            <el-input  v-model="khphone" placeholder="请输入客户手机号码" maxlength="11" style="width:90%;"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">全部客户</p>
        <div style="float: right;margin: 0 10px 0 0;color: #F56C6C;">重要提示：本功能数据为本店员工所登记客源信息汇总及有效销售记录。</div>
      </section>
      <div class="table_container">
        <el-table :data="chargebackList" stripe border>
          <el-table-column prop="num" label="序号" align="center" width="60">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="员工手机号码" align="center" width="130">
            <template scope="scope">{{scope.row.userphone}}</template>
          </el-table-column>
          <el-table-column label="城市" align="center">
            <template scope="scope">{{scope.row.cityname}}</template>
          </el-table-column>
          <el-table-column label="客户姓名" align="center">
            <template scope="scope">{{scope.row.customername}}</template>
          </el-table-column>
          <el-table-column label="客户手机号码" align="center" width="130">
            <template scope="scope">{{scope.row.customerphone}}</template>
          </el-table-column>
          <el-table-column label="小区名称" align="center">
            <template scope="scope">{{scope.row.address}}</template>
          </el-table-column>
          <el-table-column label="户型" align="center">
            <template scope="scope">{{scope.row.housetypename}}</template>
          </el-table-column>
          <el-table-column label="面积" align="center">
            <template scope="scope">{{scope.row.floorspace}}</template>
          </el-table-column>
          <el-table-column label="客户需求" align="center" width="150">
            <template scope="scope">
              <span class="spanList" :title="scope.row.cluetypes">{{scope.row.cluetypes}}</span>  
            </template>
          </el-table-column>
          <el-table-column label="需求描述" align="center" width="180">
            <template scope="scope">
              <span class="spanList" :title="scope.row.remark" v-if="scope.row.remark">{{ scope.row.remark }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="购买周期（天）" align="center" width="130">
            <template scope="scope">{{scope.row.cyclename}}</template>
          </el-table-column>
          <el-table-column label="登记日期" align="center" width="120">
            <template scope="scope">{{scope.row.regtime}}</template>
          </el-table-column>
          <el-table-column label="销售次数" align="center" width="100">
            <template scope="scope">{{scope.row.sellcount}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="150">
            <template slot-scope="scope">
              <span class="handle" @click="showBillWatch(scope.row)">
                <i class="el-icon-view"></i>查看销售记录</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangeOne"
        :page-size="10" :total="totalOne" :current-page="pageIndexOne" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>

  <!-- 销售记录 -->
  <div v-show="activeName=='second'">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="小区名称：" style="display:flex;width:30%">
            <el-input  v-model="xiaoquName" placeholder="请输入小区名称" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="商家名称：" style="display:flex;width:30%">
            <el-input  v-model="shangjianame" placeholder="请输入商家店铺名称或个人商家手机号码" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <!-- <el-form-item label="购买店铺：" style="display:flex;width:35%" class="select">
            <el-select v-model="shztid" placeholder="请选择" filterable style="width:90%;">
              <el-option v-for="(item,index) in shztArr" :key="index" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item> -->
          <el-form-item label="购买时间：" style="display:flex;width:30%">
            <el-date-picker type="daterange" v-model="orderTime" @change="changetime" style="width:90%;"
            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">销售记录</p>
      </section>
      <div class="table_container">
        <el-table :data="blacklist" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="客户姓名" align="center">
            <template scope="scope">{{scope.row.customername}}</template>
          </el-table-column>
          <el-table-column label="城市" align="center">
            <template scope="scope">{{scope.row.provincename}}-{{scope.row.cityname}}</template>
          </el-table-column>
          <el-table-column label="客户号码" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="小区名称" align="center">
            <template scope="scope">{{scope.row.address}}</template>
          </el-table-column>
          <el-table-column label="户型" align="center">
            <template scope="scope">{{scope.row.housetypename}}</template>
          </el-table-column>
          <el-table-column label="面积" align="center">
            <template scope="scope">{{scope.row.floorspace}}</template>
          </el-table-column>
          <el-table-column label="客户需求" align="center">
            <template scope="scope">{{scope.row.cluetypename}}</template>
          </el-table-column>
          <!-- <el-table-column label="需求描述" align="center" width="160">
            <template scope="scope">
              <span class="spanList" :title="scope.row.customerremark" v-if="scope.row.customerremark">{{ scope.row.customerremark }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="购买周期（天）" align="center" width="120">
            <template scope="scope">{{scope.row.cyclename}}</template>
          </el-table-column>
          <el-table-column label="登记日期" align="center">
            <template scope="scope">{{scope.row.regtime}}</template>
          </el-table-column> -->
          <el-table-column label="资源售价（元）" align="center" width="120">
            <template scope="scope">{{scope.row.price}}</template>
          </el-table-column>
          <el-table-column label="购买商家名称" align="center" width="120">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="购买时间" align="center">
            <template scope="scope">{{scope.row.paytime}}</template>
          </el-table-column>
          <el-table-column label="员工佣金(元)" align="center" width="120">
            <template scope="scope">{{scope.row.userprice}}</template>
          </el-table-column>
          <el-table-column label="备注" align="center" width="200">
            <template scope="scope">{{scope.row.remark}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangeTwo"
        :page-size="10" :total="totalTwo" :current-page="pageIndexTwo" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>

  <!-- 销售记录 右侧抽屉组件 -->
  <el-drawer title="销售记录" custom-class="registrationRecord" :visible.sync="isBillWatch" size="30%">
    <el-table :data="seeLlnrList" border style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="销售时间" property="selltime" align="center"/>
      <el-table-column label="购买商家名称" property="shopname" align="center"/>
      <el-table-column label="购买的需求" property="cluetypename" align="center"/>
    </el-table>
    <!-- 销售记录-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handlethjl"
      :current-page="pageIndexXsjl" :page-size="10" :total="pagetotal" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 初始化弹框 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity } from '../../api/newOss';
import { shopcustomergetlist, getsellrecord, shopordergetlist } from "../../api/shopWindow";
export default {
  name: "customersalerecord",
  mixins: [alertTrends],
  data() {
    return {
      show3: true, // 查询区域默认展开
      activeName: 'first', // tab切换标识
      xiaoquName: '', // 小区名称
      orderNumber: "", // 员工电话
      khphone: '', // 客户手机号
      chargebackList: [], // 全部客户
      pageIndexOne: 1, // 页码
      totalOne: 0, // 总条数
      customerid: "", // 客户ID
      isBillWatch: false, // 抽屉-通话记录
      seeLlnrList: [], // 抽屉列表
      pageIndexXsjl: 1, // 页码
      pagetotal: 0, // 总条数

      shangjianame: '', // 商家名称
      shztid: '', // 购买店铺
      shztArr: [], // 店铺集合
      orderTime: "", // 申请时间
      beginTime: "", // 开始时间
      endTime: "", // 结束时间
      blacklist: [], // 销售记录
      pageIndexTwo: 1, // 页码
      totalTwo: 0, // 总条数
      
      dialogVisibleadd: false,
      bbid:'',  //店铺id
      options1: [],

    };
  },
  methods: {
    // 切换tab
    handleClick(tab){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      if(tab.name=='first'){
        this,xiaoquName = '',
        this.orderNumber = "", // 员工电话
        this.khphone = '', // 客户手机号
        this.pageIndexOne = 1;
        this.getorder();
      }
      if(tab.name=='second'){
        this.shangjianame = ''; // 商家名称
        this.shztid = '', // 购买店铺
        this.orderTime = "", // 申请时间
        this.beginTime = "", // 开始时间
        this.pageIndexTwo = 1;
        this.gethmd();
      }
    },
    // 查询
    onSubmit() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      if(this.activeName=='first'){
        this.pageIndexOne = 1;
        this.getorder();
      }
      if(this.activeName=='second'){
        this.pageIndexTwo = 1;
        this.gethmd();
      }
    },
    // 获取全部客户列表
    getorder() {
      let obj = {
        shopid: this.bbid, // 店铺id
        address: this.xiaoquName, // 小区名称
        makerphone: this.orderNumber, // 员工手机号
        phone: this.khphone, // 客户手机号
        // pid: this.provinceId, // 省份ID
        // cid: this.cityId, // 城市ID
        pageindex: this.pageIndexOne,
        pagesize: 10
      };
      shopcustomergetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.chargebackList = data.resultObj.list;
          this.totalOne = data.resultObj.totalcount;
        }else{
          this.chargebackList = [];
          this.totalOne = 0;
        }
      })
    },
    // 分页
    currentchangeOne(val) {
      this.pageIndexOne = val;
      this.getorder();
    },
    // 销售记录
    showBillWatch(row) {
      this.isBillWatch = true;
      this.customerid = row.customerid; // 客户ID
      this.getpiaoju();
    },
    // 销售记录
    getpiaoju() {
      let obj = {
        customerid: this.customerid, // 客户ID
        pageindex: this.pageIndexXsjl,
        pagesize: 10,
      };
      getsellrecord(obj).then(data => {
        if(data.resultCode == 1){
          this.seeLlnrList = data.resultObj.list;
          this.pagetotal = data.resultObj.totalcount;
        }else{
          this.seeLlnrList = [];
          this.pagetotal = 0;
        }
      })
    },
    // 销售记录-分页
    handlethjl(val){
      this.pageIndexXsjl = val;
      this.getpiaoju();
    },
    // 获取销售记录列表
    gethmd() {
      let obj = {
        shopid: this.bbid, // 店铺id
        address: this.xiaoquName, // 小区名称
        keyword: this.shangjianame, // 商家名称
        shopname: this.shztid, // 店铺名称 模糊匹配
        bdate: this.beginTime, // 开始
        edate: this.endTime, // 结束
        pageindex: this.pageIndexTwo,
        pagesize: 10
      };
      shopordergetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.blacklist = data.resultObj.list;
          this.totalTwo = data.resultObj.totalcount;
        }else{
          this.blacklist = [];
          this.totalTwo = 0;
        }
      })
    },
    // 分页
    currentchangeTwo(val) {
      this.pageIndexTwo = val;
      this.gethmd();
    },
    // 申请时间
    changetime() {
      if(this.orderTime + "" == "null"){
        this.orderTime = ["",""]
      }
      this.beginTime = this.orderTime[0];
      this.endTime = this.orderTime[1];
    },
    // 查询店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data.resultCode == 1) {
          this.shztArr = data.resultObj;
          this.shztArr.unshift({
            id: '',
            name: "全部",
          });
        }
      })
    },
    // 初始化查店铺
    getshop(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              // this.bbid = data.resultObj[0].id;     //店铺id
              // this.gonext();
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else {      //默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id;     //店铺id
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.getorder();
      this.dialogVisibleadd = false;
    },
  },
  mounted() {
    this.getshop(); // 初始化查店铺
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// customersalerecord.vue?664be8aa